import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { CookieService } from './cookie.service';
import { AuthHttpClient } from './auth-http.service';


export class AuthHttpDynamic extends AuthHttpClient {

	public baseUrl: string;
	public token: string;

	constructor(private httpDynamic: Http, private cookieServiceDynamic: CookieService) {
		super(httpDynamic, cookieServiceDynamic);
		this.baseUrl = process.env.GATEWAY_URL;
	}

	public getBaseUrl(): string {
		return this.baseUrl;
	}

	public setUserType(userType: string) {
		if (userType === 'admin') {
			let adminCookie = this.cookieServiceDynamic.get('hackajob_bigdave');
			if (!adminCookie || !adminCookie.token) {
				this.token = null;
			} else {
				this.token = adminCookie.token;
			}
		}
	}
}(AuthHttpDynamic as any).ctorParameters = function () { return [ { type: Http }, { type: CookieService } ]; }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/auth-http-dynamic.service.ts